import { PhotoGalleryItem } from './PhotoGallery.types';

export const mockPhotos: PhotoGalleryItem[] = Array.from(
  { length: 36 },
  (_, index) => ({
    src: `https://picsum.photos/${Math.floor(Math.random() * 200 + 600)}/${Math.floor(Math.random() * 200 + 400)}?random=${index + 1}`,
    width: Math.floor(Math.random() * 200 + 600),
    height: Math.floor(Math.random() * 200 + 400),
    alt: `Zdjęcie ${index + 1}`,
    title: `Tytuł zdjęcia ${index + 1}`,
  }),
);
